/*
*   指令仓库组件
*/

import { Component, useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    ConfigProvider,
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Modal,
    Button,
    Space,
    theme,
    Tag,
    Statistic,
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
    FormatCommandContent,
    ShowIPModal,
    rootReactDom,
    GetButtonActionName,
} from '../../incs/FunHelper.js';

import PublicEntity from './PublicEntity.js';

const MODULENAME = CNF.navItems[1].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].submenu[0].ptn;

const PublicInfo = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [open, setOpen] = useState(props.open);
    const cancel = () => { setOpen(false); };
    const ok = () => {
        var copyIsOk = false;
        //  复制内容
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(props.record.content).then(() => {
                // 复制成功
                copyIsOk = true;
            }).catch((error) => {
                // 复制失败
                messageApi.error(error);
            })
        } else {
            const input = document.createElement('textarea');
            input.value = props.record.content;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            copyIsOk = true;
        }
        if (copyIsOk) {
            messageApi.success('复制成功', 1);
            setTimeout(() => {
                cancel();
            }, CNF.messageDuration * 1000);
        }
    }

    useEffect(() => {
        setOpen(props.open);
    }, [props]);
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            {contextHolder}
            <Modal
                width={480}
                open={open}
                keyboard={true}
                onOk={ok}
                onCancel={cancel}
                okText='复制'
                cancelText='取消'
            // footer={null}
            >
                <div style={{ padding: '15px 10px 10px 10px', marginTop: 10 }}>{
                    props.record.content.replace(/\]/g, '\[').split('\[').map((item, key) => {
                        if (key % 2 === 0) {
                            return item;
                        } else {
                            return FormatCommandContent(item);
                        }
                    })
                }</div>
            </Modal>
        </ConfigProvider>
    );
};

const Lists = (props) => {
    const {
        token: {
            colorPrimary,           // 主色
            colorPrimaryBg,         // 主色浅色背景色
            blue1,
            blue6,

        },
    } = theme.useToken();

    const update = (record) => { props.setOpen(true, record); }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = 'command/publics/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.group_prefix, action, MODULENAME, props.isRefresh, uri);
                break;
            default:
                break;

        }
    }

    /**
     * 显示我的API接口信息
     * @param {*} record 
     */
    const showPublicInfo = (record) => {
        rootReactDom && rootReactDom.render(
            <PublicInfo
                preGroup={props.preGroup}
                open={true}
                record={record}
            />);
    }

    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        {
            title: '标题', key: 'title',
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: '0 5px', border: 0, height: 22 }}
                onClick={() => { showPublicInfo(record); }}>{record.title}</Button>
        },
        { title: '角色', dataIndex: 'role', key: 'role', },
        { title: '场景', dataIndex: 'scene', key: 'scene', },
        {
            title: '收藏数', key: 'collect_count',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '30%' : '40%' }} color={colorPrimaryBg}><Statistic valueStyle={{ fontSize: CNF.fontSize - 2, color: colorPrimary }} value={record.collect_count} /></Tag>

        },
        {
            title: '使用数', key: 'use_count',
            render: (record) => <Tag style={{ width: isGTscreenWidth ? '30%' : '40%' }} color={blue1}><Statistic valueStyle={{ fontSize: CNF.fontSize - 2, color: blue6 }} value={record.use_count} /></Tag>

        },
        { title: '状态', dataIndex: 'status', key: 'status', width: CNF.tableStatusColumnWidth, },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetButtonActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => <>共{props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条</>,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            record: null,
            open: false,
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            title: '',
            role: '',
            scene: '',
            status: CNF.status[0].value,
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeTitle = (e) => { this.setState({ title: e.target.value }); this.search(); }
    changeRole = (e) => { this.setState({ role: e.target.value }); this.search(); }
    changeScene = (e) => { this.setState({ scene: e.target.value }); this.search(); }
    changeStatus = (value) => { this.setState({ status: value === undefined ? '' : value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    setOpen = (value, record) => { this.setState({ open: value, record: record }); }
    create = () => { this.setOpen(true, null); }

    /**
     * 获取列表
     */
    getLists() {
        const _this = this;
        const params = {
            'title': this.state.title,
            'role': this.state.role,
            'scene': this.state.scene,
            'status': this.state.status,
            'page_size': CNF.pageSize,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}command/publics${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 2 : 3}>
                        <Input
                            onChange={this.changeTitle}
                            placeholder='标题'
                            value={this.state.title}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeRole}
                            placeholder='角色'
                            value={this.state.role}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Input
                            onChange={this.changeScene}
                            placeholder='场景'
                            value={this.state.scene}
                        />
                    </Col>
                    <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                        <Select
                            allowClear
                            placeholder='状态'
                            style={{ width: '100%' }}
                            onChange={(value) => this.setStatus(value)}
                            value={this.state.status ? this.state.status : undefined}
                            options={CNF.status.map((item, index) => ({
                                key: index,
                                value: item.value,
                                label: item.label
                            }))}
                        />
                    </Col>
                    <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                        {
                            this.props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                                <Button
                                    title={CNF.actionName.CREATE + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<PlusOutlined />}
                                    onClick={() => {
                                        this.create();
                                    }}>
                                    {CNF.actionName.CREATE}
                                </Button>
                            ) : ''
                        }
                    </Space>
                    <PublicEntity
                        btnLists={this.props.btnLists}
                        policy={this.props.policy}
                        open={this.state.open}
                        record={this.state.record}
                        setOpen={this.setOpen}
                        isRefresh={this.isRefresh}
                    />
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            btnLists={this.props.btnLists}
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            setOpen={this.setOpen}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT